var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.487,
    height: 15.75,
    viewBox: "0 0 15.487 15.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-menu",
    "data-name": "Icon ionic-ios-menu",
    transform: "translate(-4.5 -10.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M19.342,12.375H5.145c-.355,0-.645-.506-.645-1.125h0c0-.619.29-1.125.645-1.125h14.2c.355,0,.645.506.645,1.125h0C19.987,11.869,19.7,12.375,19.342,12.375Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M19.342,19.125H5.145c-.355,0-.645-.506-.645-1.125h0c0-.619.29-1.125.645-1.125h14.2c.355,0,.645.506.645,1.125h0C19.987,18.619,19.7,19.125,19.342,19.125Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M19.342,25.875H5.145c-.355,0-.645-.506-.645-1.125h0c0-.619.29-1.125.645-1.125h14.2c.355,0,.645.506.645,1.125h0C19.987,25.369,19.7,25.875,19.342,25.875Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/Icon-menu.07aa23da54e4b503b1a9a4ca836c3975.svg";
export { ForwardRef as ReactComponent };